import React from "react";
import Flagship from "../../core/flagship";
import Field from "../misc/Field";
import { connect } from "react-redux";
import { Loader, Header, Grid, Modal, Button, Icon } from "semantic-ui-react";
import {
  shouldShowField,
  empty,
  getServiceNiceName,
} from "../../utils/helpers";
import FlightField from "../misc/FlightField";
import moment from "moment";

class IoProductEditModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.onUpdateFlights = this.onUpdateFlights.bind(this);
    this.getSubServiceFields = this.getSubServiceFields.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.setFlightSubFieldsMissing = this.setFlightSubFieldsMissing.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      id: this.props.ioProductId,
      ioProductName: this.props.ioProduct.io_product_name,
      parent_rfp: 0,
      vendor: "",
      cogs: "",
      price: "",
      errors: [],
      ioProductForm: {},
      ioProductData: [],
      originalIoProductData: [],
      changed: false,
      flights: this.props.ioProduct.flights,
      flighted: false,
      requiredMissing: true,
      flightSubFieldsMissing: false,
      trueService: false,
    };
  }

  componentDidMount() {
    // Get Form
    this.getIoProductForm();
  }

  getIoProductForm() {
    let self = this;
    let service = this.props.ioProduct.io_product_type;

    let mainService = false;
    let subService = false;
    let flighted = false;

    Flagship.config.lineItemServices.map(function (element) {
      if (element.value === service) {
        mainService = service;
        flighted = element.flighted;
      } else if (element.hasOwnProperty("subOptions")) {
        element.subOptions.map(function (subItem) {
          if (subItem.value === service) {
            mainService = element.value;
            flighted = subItem.flighted;
            subService = service;
          }
        });
      }
    });

    if (subService !== false) {
      // If dealing with a sub-service, get both levels of fields
      this.getFormSubService(mainService, subService, flighted);
    } else {
      Flagship.get(
        "fields/io-product_" + mainService,
        {
          withData:
            typeof this.props.ioProductId === "undefined"
              ? false
              : this.props.ioProductId,
          active: true,
          dataSource: "io_product",
          instance: this.props.instance,
        },
        function (response) {
          if (response.data.success === true) {
            self.setState(
              {
                loading: false,
                ioProductData: response.data.fieldData,
                originalIoProductData: response.data.fieldData,
                ioProductForm: response.data.results,
                trueService: mainService,
                flighted,
              },
              self.checkRequired
            );
          } else {
            Flagship.error(
              "Error getting line item form from Flagship API server.",
              self.props.recordId,
              self.props.userId
            );
          }
        },
        function (err) {
          Flagship.error(
            "Error getting line item form from Flagship API server: " + err,
            self.props.recordId,
            self.props.userId
          );
        }
      );
    }
  }

  getFormSubService(mainService, subService, flighted) {
    let self = this;

    // First get main service fields
    Flagship.get(
      "fields/io-product_" + mainService,
      {
        withData:
          typeof this.props.ioProductId === "undefined"
            ? false
            : this.props.ioProductId,
        active: true,
        dataSource: "io_product",
      },
      function (response) {
        if (response.data.success === true) {
          self.setState(
            {
              ioProductForm: response.data.results,
              ioProductData: response.data.fieldData,
              originalIoProductData: response.data.fieldData,
              trueService: subService,
              flighted,
            },
            function () {
              self.getSubServiceFields(subService);
            }
          );
        } else {
          Flagship.error(
            "Error getting IO product form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting IO product form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getSubServiceFields(subService) {
    let self = this;

    // Now add sub service fields
    Flagship.get(
      "fields/io-product_" + subService,
      {
        active: true,
        withData:
          typeof this.props.ioProductId === "undefined"
            ? false
            : this.props.ioProductId,
        dataSource: "io_product",
      },
      function (response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.ioProductForm,
            ...response.data.results,
          ];
          let combinedData = Object.assign(
            self.state.ioProductData,
            response.data.fieldData
          );

          self.setState(
            {
              ioProductForm: combinedForm,
              ioProductData: combinedData,
              loading: false,
            },
            self.checkRequired
          );
        } else {
          Flagship.error(
            "Error getting IO product form (sub-service) from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting IO product form (sub-service) from Flagship API server: " +
            err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) === -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    this.state.ioProductForm.length &&
      this.state.ioProductForm.map(function (item) {
        if (
          self.state.flightSubFieldsMissing ||
          ((item.required === true || item.required === 1) &&
            empty(self.state.ioProductData[item.field_id]) &&
            shouldShowField(item, self.state.ioProductData))
        ) {
          requiredMissing = true;
        }
      });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  setFlightSubFieldsMissing(flightSubFieldsMissing) {
    this.setState(
      {
        flightSubFieldsMissing,
      },
      this.checkRequired
    );
  }

  onChange(e, data, field) {
    if (field === "name") {
      this.setState({
        ioProductName: e.target.value,
      });
    } else if (field === "flights") {
      this.onUpdateFlights(data);
    } else {
      let newIoProductData = Object.assign({}, this.state.ioProductData);
      newIoProductData[field] = data;

      this.setState(
        {
          changed: true,
          ioProductData: newIoProductData,
        },
        this.checkRequired
      );
    }
  }

  editName() {
    this.setState({
      editingName: true,
    });
  }

  onUpdateFlights(flights) {
    this.setState(
      {
        flights: flights,
      },
      this.checkRequired
    );
  }

  saveAndExit() {

    if (this.props.accessLevel !== 2) {
      return;
    }

    // Check for invalid flights (end before start or spanning more than 1 calendar month)
    const flightsEndingBeforeStart = [];
    const flightsSpanningMonths = [];
    this.state.flights.forEach((flight) => {
      if (moment(flight.endDate).isBefore(flight.startDate)) {
        flightsEndingBeforeStart.push(flight);
      } else if (!moment(flight.startDate).isSame(flight.endDate, "month")) {
        flightsSpanningMonths.push(flight);
      }
    });



    if (flightsEndingBeforeStart.length > 0 && this.props.ioProduct.io_product_type !== "email-marketing") {
      const reasons = [];


        const months = Array.from(new Set(
          flightsEndingBeforeStart.map(f => moment(f.startDate).format("MMM 'YY"))
        ));
        const monthList = months.length > 1
          ? months.slice(0, -1).join(", ") + " & " + months[months.length - 1]
          : months[0];
        reasons.push(
          `Flights can't end before they begin; check the flight${months.length > 1 ? 's' : ''} starting in ${monthList}.`
        );
      

      Flagship.error(
        reasons.join("\n\n"),
        this.props.recordId,
        this.props.userId
      );
      return;
    }

    if (flightsSpanningMonths.length > 0) {
      const reasons = [];

        const months = Array.from(new Set(
          flightsSpanningMonths.map(f => moment(f.startDate).format("MMM 'YY"))
        ));
        const monthList = months.length > 1
          ? months.slice(0, -1).join(", ") + " & " + months[months.length - 1]
          : months[0];
        reasons.push(
          `Flights can't span more than one calendar month. Check flights starting in ${monthList}.`
        );
      

      Flagship.error(
        reasons.join("\n\n"),
        this.props.recordId,
        this.props.userId
      );
      return;
    }

    let self = this;
    Flagship.post(
      "io-product/update/" + self.props.ioProductId,
      {
        data: self.state.ioProductData,
        name: self.state.ioProductName,
        flights: self.state.flights,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.event(
            "update-io-product",
            {
              ioProductId: self.props.ioProductId,
              ioProductKey: self.props.ioProduct.io_product_key,
              ioProductName: self.props.ioProduct.io_product_name,
              oldData: self.state.originalIoProductData,
              newData: self.state.ioProductData,
            },
            self.props.recordId,
            self.props.userId
          );
          Flagship.notify("IO Product updated.");
          self.setState(self.getInitialState(), function () {
            if (typeof self.props.onUpdateIoProduct === "function") {
              self.props.onUpdateIoProduct();
            }
          });
        } else {
          Flagship.error(
            "Error updating IO product.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error updating IO product: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    if (this.state.loading === true) {
      return <Loader />;
    } else {
      let self = this;
      let serviceNiceName = getServiceNiceName(
        this.props.ioProduct.io_product_type
      );
      return (
        <Modal
          open={this.props.open}
          onClose={this.props.cancelUpdate}
          closeIcon
          closeOnDimmerClick={false}
        >
          {this.state.changed === false ? (
            <Button
              floated="right"
              className="view-edit-io-product"
              onClick={this.props.swapToView}
            >
              <Icon name="eye" />
              View IO Product
            </Button>
          ) : (
            <span className="io-product-modified float-right">Modified</span>
          )}
          <Header>
            {this.props.ioProduct.io_product_key + " - "}

            {this.state.editingName === true ? (
              <span className="ui input">
                <input
                  autoFocus
                  placeholder={self.state.ioProductName}
                  onChange={(e, data) => self.onChange(e, data, "name")}
                  style={{
                    minWidth: "400px",
                    maxWidth: "100%",
                  }}
                />
              </span>
            ) : (
              [
                <span key="editable-title" className="editable-title" onClick={self.editName}>
                  {this.state.ioProductName}
                </span>,
                <div key="service-name">
                  {serviceNiceName !== self.state.ioProductName ? (
                    <div className="gray-text">
                      <small> ({serviceNiceName}) </small>
                    </div>
                  ) : null}
                </div>
              ]
            )}
          </Header>
          <Modal.Content>
            <div>
              <Grid>
                <Grid.Column width={16}>
                  <Header as="h3">Edit IO Product Info</Header>
                  {this.state.flighted === true ? (
                    <div className="flight-field-container clearfix">
                      <FlightField
                        {...this.props.attributes}
                        fields={this.props.options}
                        value={this.state.flights}
                        fieldId="flights"
                        onChange={(e, data) => {
                          this.onChange(e, data, "flights");
                        }}
                        social={this.state.trueService === "social-media-ads"}
                        email={this.state.trueService === "email-marketing"}
                        callrail={this.state.trueService === "callrail"}
                        recordType="IO"
                        setFlightSubFieldsMissing={
                          self.setFlightSubFieldsMissing
                        }
                      />
                    </div>
                  ) : null}

                  {this.state.ioProductForm.length &&
                    this.state.ioProductForm.map(function (item, i) {
                      if (!empty(self.state.ioProductData)) {
                        let value = self.state.ioProductData.hasOwnProperty(
                          item.field_id
                        )
                          ? self.state.ioProductData[item.field_id]
                          : "";

                        return shouldShowField(
                          item,
                          self.state.ioProductData
                        ) ? (
                          <Field
                            contentType="ioProduct"
                            addError={self.addError.bind(self)}
                            clearError={self.clearError.bind(self)}
                            model={"IoProduct." + i}
                            key={"field-" + i}
                            value={value}
                            default={item.field_value}
                            setFlightSubFieldsMissing={
                              self.setFlightSubFieldsMissing
                            }
                            filterInput={
                              item.validation !== "" ? item.validation : null
                            }
                            onChange={(e, data, fieldId) =>
                              self.onChange(e, data, fieldId, i)
                            }
                            {...item}
                          />
                        ) : null;
                      }
                    })}
                </Grid.Column>
              </Grid>
            </div>
          </Modal.Content>
          <Modal.Actions>
            {this.state.requiredMissing === false ? (
              <Button primary onClick={this.saveAndExit}>
                <Icon name="plus" /> Update IO Product
              </Button>
            ) : (
              <span className="red-text">
                {this.state.flightSubFieldsMissing
                  ? "Missing required flight data."
                  : "Required fields missing."}
              </span>
            )}
            <Button color="grey" onClick={this.props.cancelUpdate}>
              <Icon name="dont" /> Cancel
            </Button>
          </Modal.Actions>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps, null)(IoProductEditModal);



// WEBPACK FOOTER //
// ./src/components/modals/IoProductEditModal.js